import { useEffect } from "react";
import { insideHeyDayNewsSite } from "../appMode";

/** The embedding site's masthead owns the phone's sidebar and thread controls. */
export function useSiteCommands(toggleSidebar: () => void, newThread: () => void) {
  useEffect(() => {
    if (!insideHeyDayNewsSite) return;
    const onMessage = (event: MessageEvent<unknown>) => {
      if (event.source !== window.parent || event.origin !== window.location.origin) return;
      if (typeof event.data !== "object" || event.data === null || !("type" in event.data)) return;
      if (event.data.type === "heydex:toggle-sidebar") toggleSidebar();
      if (event.data.type === "heydex:new-thread") newThread();
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [newThread, toggleSidebar]);
}
